/* Riden reviews slider: arrows, dots and optional auto scroll.
   Kept in an asset rather than inline in the section so the Liquid file stays small and simple. */
(function () {
  function initSlider(root) {
    if (root.__aerVoicesSlider) return;
    root.__aerVoicesSlider = true;

    var track = root.querySelector('[data-aer-voices-track]');
    var prev = root.querySelector('[data-aer-voices-prev]');
    var next = root.querySelector('[data-aer-voices-next]');
    var dots = root.querySelector('[data-aer-voices-dots]');
    if (!track) return;

    var wantArrows = root.dataset.arrows === 'true';
    var wantDots = root.dataset.dots === 'true';
    var wantAuto = root.dataset.autoplay === 'true';
    var speed = (Number(root.dataset.speed) || 6) * 1000;
    var timer = null;
    var paused = false;

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('.aer-vcard'));
    }
    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function scrolls() {
      return maxScroll() > 4;
    }
    function step() {
      var c = cards();
      if (c.length < 2) return c.length ? c[0].offsetWidth : 0;
      return c[1].offsetLeft - c[0].offsetLeft;
    }
    function pages() {
      var st = step();
      return st > 0 ? Math.round(maxScroll() / st) + 1 : 1;
    }
    function current() {
      var st = step();
      return st > 0 ? Math.round(track.scrollLeft / st) : 0;
    }
    function go(i) {
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    function pause() {
      paused = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function paint() {
      var on = scrolls();
      if (prev) {
        prev.hidden = !(wantArrows && on);
        prev.disabled = track.scrollLeft <= 2;
      }
      if (next) {
        next.hidden = !(wantArrows && on);
        next.disabled = track.scrollLeft >= maxScroll() - 2;
      }
      if (dots && !dots.hidden) {
        var c = current();
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].setAttribute('aria-current', i === c ? 'true' : 'false');
        }
      }
    }
    function buildDots() {
      if (!dots) return;
      if (!wantDots || !scrolls()) {
        dots.hidden = true;
        dots.innerHTML = '';
        return;
      }
      var n = pages();
      dots.hidden = false;
      if (dots.children.length !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'aer-voices__dot';
          d.setAttribute('aria-label', 'Go to review ' + (i + 1));
          bindDot(d, i);
          dots.appendChild(d);
        }
      }
      paint();
    }
    function bindDot(el, idx) {
      el.addEventListener('click', function () {
        go(idx);
        pause();
      });
    }
    function auto() {
      if (!wantAuto || paused || !scrolls()) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (track.scrollLeft >= maxScroll() - 2) {
          go(0);
        } else {
          go(current() + 1);
        }
      }, speed);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(Math.max(0, current() - 1));
        pause();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(current() + 1);
        pause();
      });
    }
    track.addEventListener('scroll', paint, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pause, { passive: true });
    });
    root.addEventListener('mouseenter', function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    });
    root.addEventListener('mouseleave', function () {
      if (!paused) auto();
    });
    window.addEventListener('resize', function () {
      buildDots();
      paint();
    });

    buildDots();
    paint();
    auto();
  }

  function boot() {
    document.querySelectorAll('[data-aer-voices]').forEach(initSlider);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
  document.addEventListener('shopify:section:load', boot);
})();
